export const EXPENSE_CATALOG = [
    // 食事
    { title: "飲み会", category: "food", keywords: ["のみかい", "nomikai", "宴会"] },
    { title: "居酒屋", category: "food", keywords: ["いざかや", "izakaya"] },
    { title: "ランチ", category: "food", keywords: ["らんち", "lunch", "昼食", "ひるごはん"] },
    { title: "ディナー", category: "food", keywords: ["でぃなー", "dinner", "夕食", "ばんごはん"] },
    { title: "カフェ", category: "food", keywords: ["かふぇ", "cafe", "喫茶", "コーヒー"] },
    { title: "焼肉", category: "food", keywords: ["やきにく", "yakiniku"] },
    { title: "二次会", category: "food", keywords: ["にじかい", "nijikai"] },
    { title: "朝ごはん", category: "food", keywords: ["あさごはん", "朝食", "モーニング"] },
    { title: "コンビニ", category: "food", keywords: ["こんびに", "convini", "convenience"] },
    { title: "お酒・ドリンク", category: "food", keywords: ["おさけ", "どりんく", "drink", "酒"] },
    { title: "BBQ", category: "food", keywords: ["ばーべきゅー", "bbq", "バーベキュー"] },
    // 交通
    { title: "電車代", category: "transport", keywords: ["でんしゃ", "densha", "train", "運賃"] },
    { title: "タクシー", category: "transport", keywords: ["たくしー", "taxi"] },
    { title: "新幹線", category: "transport", keywords: ["しんかんせん", "shinkansen"] },
    { title: "飛行機", category: "transport", keywords: ["ひこうき", "hikouki", "航空券", "フライト"] },
    { title: "レンタカー", category: "transport", keywords: ["れんたかー", "rentacar", "rent a car"] },
    { title: "ガソリン代", category: "transport", keywords: ["がそりん", "gasoline", "給油"] },
    { title: "高速道路料金", category: "transport", keywords: ["こうそく", "etc", "高速代"] },
    { title: "駐車場", category: "transport", keywords: ["ちゅうしゃじょう", "parking"] },
    { title: "バス代", category: "transport", keywords: ["ばす", "bus"] },
    // 宿泊
    { title: "ホテル", category: "stay", keywords: ["ほてる", "hotel", "宿"] },
    { title: "旅館", category: "stay", keywords: ["りょかん", "ryokan"] },
    { title: "民泊", category: "stay", keywords: ["みんぱく", "airbnb"] },
    { title: "コテージ・貸別荘", category: "stay", keywords: ["こてーじ", "cottage", "別荘"] },
    // レジャー
    { title: "入場料", category: "leisure", keywords: ["にゅうじょうりょう", "チケット", "ticket"] },
    { title: "カラオケ", category: "leisure", keywords: ["からおけ", "karaoke"] },
    { title: "映画", category: "leisure", keywords: ["えいが", "movie", "cinema"] },
    { title: "温泉", category: "leisure", keywords: ["おんせん", "onsen", "銭湯"] },
    { title: "テーマパーク", category: "leisure", keywords: ["てーまぱーく", "遊園地", "themepark"] },
    { title: "スキー・スノボ", category: "leisure", keywords: ["すきー", "すのぼ", "ski", "snowboard", "リフト券"] },
    { title: "ゴルフ", category: "leisure", keywords: ["ごるふ", "golf"] },
    // 買い物
    { title: "食材・買い出し", category: "shopping", keywords: ["しょくざい", "かいだし", "スーパー", "買い物"] },
    { title: "日用品", category: "shopping", keywords: ["にちようひん", "雑貨"] },
    { title: "お土産", category: "shopping", keywords: ["おみやげ", "omiyage", "土産"] },
    // 生活費
    { title: "家賃", category: "utility", keywords: ["やちん", "rent"] },
    { title: "光熱費", category: "utility", keywords: ["こうねつひ", "電気代", "ガス代", "水道代"] },
    { title: "通信費", category: "utility", keywords: ["つうしんひ", "wifi", "ネット代"] },
    { title: "サブスク", category: "utility", keywords: ["さぶすく", "subscription", "定額"] },
    // ギフト
    { title: "プレゼント", category: "gift", keywords: ["ぷれぜんと", "present", "gift"] },
    { title: "ご祝儀", category: "gift", keywords: ["ごしゅうぎ", "お祝い"] },
    { title: "誕生日ケーキ", category: "gift", keywords: ["たんじょうび", "cake", "ケーキ"] },
    // その他
    { title: "立替金", category: "other", keywords: ["たてかえ", "立て替え"] },
    { title: "精算", category: "other", keywords: ["せいさん", "調整"] },
];
/**
 * 支出名からカテゴリを推測する。
 *
 * カテゴリはユーザーに選ばせない (一覧の絵文字を出すためだけの情報なので、
 * わざわざ 1 タップ使わせる価値がない)。代わりに、候補から選ばずに
 * 手で打った場合でもここで推測して、それらしい絵文字が出るようにする。
 * 判断できなければ "other" を返す。
 */
export function inferCategory(title) {
    const normalized = title.trim().toLowerCase();
    if (normalized === "")
        return "other";
    // 「居酒屋 (二次会)」のように前後に文字が付いていても拾えるよう、部分一致で見る。
    // 短い語が偶然ヒットするのを避けるため、長い語から順に照合する。
    const candidates = EXPENSE_CATALOG.flatMap((item) => [item.title, ...item.keywords].map((word) => ({ word: word.toLowerCase(), category: item.category }))).sort((a, b) => b.word.length - a.word.length);
    return candidates.find((c) => normalized.includes(c.word))?.category ?? "other";
}
//# sourceMappingURL=catalog.js.map